<template >
  <div class="base_box">
    <div class="title"> 房源设置</div>
    <div class="form-item">
      <span>录入出售房源时，面积是否允许输入</span>
      <div class="items">
        <el-select v-model="info.whetherUpdateArea" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.text" :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="form-item">
        <span>
        房客源匹配中，系统将匹配度大于
          <el-input style="width: 100px;" :value="info.matchingDegree" @input="formatMatchValue" placeholder="请输入"></el-input>
          %的数据展示在对应的房客源匹配列表中
        </span>
      <span style="color: orange">
          (匹配度的值配置范围为60~100之间的正整数)
        </span>
    </div>
<!--    <div class="form-item">-->
<!--      <span>房屋状态为签约中，预定和成交的禁止编辑和纠错功能</span>-->
<!--      <el-select v-model="info.whetherUpdateArea" placeholder="请选择">-->
<!--        <el-option v-for="item in options" :key="item.value" :label="item.text" :value="item.value">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--    </div>-->
    <div class="form-item">
      <span>房屋状态无效、已售房源，</span>
      <el-input-number v-model="info.invalidTradeDelete" controls-position="right" size="mini"></el-input-number>
      <span>天后系统自动删除</span>
    </div>
    <div class="form-item">
      <span>抢盘池房源，</span>
      <el-input-number v-model="info.robDelete" controls-position="right" size="mini"></el-input-number>
      <span>天后系统自动删除</span>
    </div>
    <div class="footer_buten">
      <button class="save" @click="saveCheck" >保存</button>
    </div>
  </div>
</template>
<script>
import {houseSettingQuery, houseSettingUpdate} from "@/api/systemSetup";
export default {
  name: "houseSet",
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
  },
  data(){
    return {
      options: [
        { value: "YES", text: "是" },
        { value: "NO", text: "否" }
      ],
      info: {
        enterpriseCode: "",
        id: null,
        invalidTradeDelete: null,
        matchingDegree: null,
        robDelete: 0,
        whetherUpdateArea: "NO"
      },
      area: null,
      matchingDegree: null,
    }
  },
  mounted() {
    this.queryInfo();
  },
  methods:{
    formatMatchValue(e) {
      this.info.matchingDegree = e.replace(/[^\d]/g, '');
    },
    queryInfo() {
      this.$post(houseSettingQuery).then((res)=> {
        if (res.success) {
          this.info = res.data;
        }
      })
    },
    saveCheck() {
      this.$post(houseSettingUpdate, this.info).then((res)=> {
        if (res.success) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.base_box {
  .title {
    line-height: 50px;
    font-weight: bold;
  }
  .form-item {
    display:flex;
    align-items:center;
    font-size:14px;
    margin-bottom: 14px;
  }
  .el-select {
    width: 120px;
    margin-left: 10px;
  }
  /deep/ .el-input__inner {
    width: 100%;
    margin: 0;
  }
  .footer_buten {
    text-align: right;
  }
}

</style>